import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';

@Component({
  selector: 'app-mi-increment-int',
  standalone: true,
  imports: [InputNumberModule, FormsModule, ReactiveFormsModule,],
  templateUrl: './mi-increment-int.component.html',
  styleUrl: './mi-increment-int.component.scss'
})
export class MiIncrementIntComponent implements OnInit {
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  formName: FormGroup;
  placeholder: any;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
  }
}
